'use client';

import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { RequestServiceCalendarWeekProps } from '../../types';
import { CatHeading } from '@blocks-react/components/Heading';
import { addDays } from 'date-fns/addDays';
import { format } from 'date-fns/format';
import { getMonth } from 'date-fns/getMonth';
import { lastDayOfMonth } from 'date-fns/lastDayOfMonth';

export const RequestServiceCalendarWeek: FC<
  PropsWithChildren<RequestServiceCalendarWeekProps>
> = ({ weekStartDate }) => {
  const [lastDay, setLastDay] = useState<Date>(addDays(weekStartDate, 6));
  const getLastDate = (weekEndDate: Date, monthLastDate: Date) => {
    if (getMonth(weekEndDate) !== getMonth(monthLastDate)) {
      setLastDay(monthLastDate);
    } else setLastDay(weekEndDate);
  };
  useEffect(() => {
    const monthLastDate = lastDayOfMonth(weekStartDate);
    const weekEndDate = addDays(weekStartDate, 6);
    getLastDate(weekEndDate, monthLastDate);
  }, [weekStartDate]);
  return (
    <CatHeading variant="body-sm" className="text-nowrap">{`${format(
      weekStartDate,
      'MM/dd/yyyy'
    )} - ${format(lastDay, 'MM/dd/yyyy')}`}</CatHeading>
  );
};
